import getFilters from 'components/Filters';
import DOCUMENTATION_ROLE, {
  documentationRoles,
} from 'enums/DocumentationRole';
import { FC, useContext } from 'react';
import { DocumentationFilesContext, TagColumnNames } from '..';

const Filters = getFilters<TagColumnNames>();
const DocumentationFilesFilters: FC = () => {
  const { search, setSearch, tags, setTags, take, setTake } = useContext(
    DocumentationFilesContext,
  );
  return (
    <Filters
      tagList={[
        {
          columnName: 'role',
          columnTitle: "Type d'utilisateur",
          tags: documentationRoles.map((role) => ({
            name: role,
            label: DOCUMENTATION_ROLE[role],
          })),
        },
      ]}
      state={{ tags, search: search, take }}
      setTags={setTags}
      setSearch={setSearch}
      setTake={setTake}
    />
  );
};

export default DocumentationFilesFilters;
